<script setup lang="ts">
  import type { SupportSession } from '@gat-ship/types'
  import {
    Button,
    Label,
    Modal,
    ModalFooter,
    ModalHeader,
    ModalHeaderTitle,
    ModalSection,
    ModalContent
  } from '@gat-ship/vue-components'
  import { useFormatting } from '@gat-ship/utils'
  import { ref } from 'vue'

  const { formatDate } = useFormatting()

  const isOpen = ref(false)

  const supportSession = ref<SupportSession>()

  export type ShowSupportSessionDetailsDialogParams = {
    supportSession: SupportSession
  }

  function showModal(payload: ShowSupportSessionDetailsDialogParams) {
    const sessionId = payload.supportSession.sessionId
    const newSupportSession = { ...payload.supportSession, sessionId }
    supportSession.value = newSupportSession
    isOpen.value = true
  }

  defineExpose({
    showModal
  })
</script>

<template>
  <Modal v-model:open="isOpen" type="dialog">
    <ModalHeader>
      <ModalHeaderTitle> Session Details </ModalHeaderTitle>
    </ModalHeader>
    <ModalContent>
      <ModalSection>
        <div>
          <Label
            class="text-xs font-medium tracking-wider text-neutral-700 dark:text-neutral-200"
            >Tenant</Label
          >
          <div class="mt-1 text-sm font-medium text-neutral-950">
            {{ supportSession?.ownerTenantName ?? '-' }}
          </div>
        </div>
        <div>
          <Label
            class="text-xs font-medium tracking-wider text-neutral-700 dark:text-neutral-200"
            >Support Duration</Label
          >
          <div class="mt-1 text-sm font-medium text-neutral-950">
            {{ formatDate(supportSession?.grantedFrom, 'long') }}
            -
            {{ formatDate(supportSession?.grantedTo, 'long') }}
          </div>
        </div>
        <div>
          <Label
            class="text-xs font-medium tracking-wider text-neutral-700 dark:text-neutral-200"
            >Requested By</Label
          >
          <div class="mt-1 text-sm font-medium text-neutral-950">
            {{ supportSession?.requestedByFullName ?? '-' }}
          </div>
        </div>
        <div>
          <Label
            class="text-xs font-medium tracking-wider text-neutral-700 dark:text-neutral-200"
            >Granted Tenant Admin</Label
          >
          <div class="mt-1 text-sm font-medium text-neutral-950">
            {{ supportSession?.grantedTenantAdmin ? 'Yes' : 'No' }}
          </div>
        </div>
        <div>
          <Label
            class="text-xs font-medium tracking-wider text-neutral-700 dark:text-neutral-200"
            >Support Person</Label
          >
          <div class="mt-1 text-sm font-medium text-neutral-950">
            {{ supportSession?.supportPersonFullName ?? '-' }}
          </div>
        </div>
      </ModalSection>
    </ModalContent>
    <ModalFooter>
      <Button variant="ghost" @click="isOpen = false"> Close </Button>
    </ModalFooter>
  </Modal>
</template>
